import { authSlice } from '@shared-core/features/auth/slice'
import { backendSlice } from '@shared-core/features/backend/slice'
import { configSlice } from '@shared-core/features/config/slice'
import { envSlice } from '@shared-core/features/env/slice'
import { notificationsSlice } from '@shared-core/features/notifications/slice'
import { settingsSlice } from '@shared-core/features/settings/slice'

export const reducers = {
  [authSlice.name]: authSlice.reducer,
  [backendSlice.name]: backendSlice.reducer,
  [configSlice.name]: configSlice.reducer,
  [settingsSlice.name]: settingsSlice.reducer,
  [envSlice.name]: envSlice.reducer,
  [notificationsSlice.name]: notificationsSlice.reducer,
}

export const slices = {
  [authSlice.name]: authSlice,
  [backendSlice.name]: backendSlice,
  [configSlice.name]: configSlice,
  [settingsSlice.name]: settingsSlice,
  [envSlice.name]: envSlice,
  [notificationsSlice.name]: notificationsSlice,
}
